import { create } from "zustand";
import { PostConnect, GetConnect } from "../../Core/Connect";
import { useAuthStore } from "../";
import { useLoaderStore } from "../loader";

//const loaderAction = useLoaderStore.getState().loaderAction;

export const useReportv2Store = create((set, get) => ({
  reports: [],
  createReports: () => {
    GetConnect(
      `users/get/${useAuthStore.getState().user.data.id}`,
      async (data) => {
        set({
          reports: {
            status: {
              1: "Planned",
              2: "Inprogress",
              3: "Completed",
              4: "Incomplete",
            },
            centrals: data[0].centrals,
          },
        });
        await get().getMaintanancePeriods();
        await get().getMaintananceCound();
      },
      useAuthStore.getState().user.data.token
    );
  },
  // Bakım sayısını alan fonksiyon
  getMaintananceCound: () => {
    set({
      reports: {
        ...get().reports,
        works: 50,
        completed: 20,
        incomplete: 5,
        inprogress: 10,
        planned: 15,
      },
    });

    return true;
  },
  // periodları alan fonksiyon
  getMaintanancePeriods: async () => {
    await GetConnect("periods/get", async (data) => {
      set({ reports: { ...get().reports, periods: data } });
    });
    return true;
  },
  // Tarih aralığındaki bakımları çağıracak fonksiyon
  getMaintananceBetween: {},
}));
